import { Tooltip } from "@material-ui/core";
import React from "react";
import starEmpty from '../../assets/star-empty.svg'
import starFilled from '../../assets/star-filled.svg'
const divTheme = {
  width: '100%', height: 50,
  backgroundColor: 'rgba(0, 24, 64, 0.2)',
  marginBottom: 5,
  borderRadius: 5,
  padding: '1%',
}

export class FilterSelector extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isHovering: new Set()
    }
  }

  render() {
    return (
      <React.Fragment>
        <div style={{
          width: '100%', height: 50,
          marginBottom: 5,
          borderRadius: 5,
          padding: '1%',
        }} 
        className="ab-filterselector"
        onClick={() => { this.props.onDisplayedFiltersExpanded() }}>
          <p style={{ textAlign: 'center' }}><b>{this.props.label}</b></p>
        </div>
        {this.props.showFilters && this.props.filters.map((obj, idx) => {
          if ((obj.hasOwnProperty("isAquisition") && obj.isAquisition == false) || (obj.hasOwnProperty("isAquisition") && obj.isAquisition && this.props.showAcquisition)) {
            return (
              <div
                customobjdata={JSON.stringify({...obj,createNewId: true})}
                id={obj.id}
                key={obj.id}
                draggable="true"
                onDragStart={(e) => { this.props.drag(e) }}
                style={{ ...divTheme, position: 'relative' }}
                onMouseEnter={() => {
                  this.setState(e => {
                    e.isHovering.add(obj.label)
                    return e
                  })
                }}
                onMouseLeave={() => {
                  this.setState(e => {
                    e.isHovering.delete(obj.label)
                    return e
                  })
                }}
              >
                <p style={{ marginTop: '1vh' }}>{obj.label}</p>
                {this.state.isHovering.has(obj.label) && (
                  <div style={{ position: 'absolute', top: 5, right: 5 }} onClick={() => { this.props.onFilterTag(idx) }}>
                    {this.props.activeFavoriteFilters.has(obj.label) ? (
                      <Tooltip title="Untag this filter">
                        <img src={starFilled} style={{ height: 25, width: 25 }}></img>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Tag this filter">
                        <img src={starEmpty} style={{ height: 25, width: 25 }}></img>
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
            )
          }
        })}
      </React.Fragment>)
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/dragAndDrop/filterSelector.jsx